import config from "../../../config/config";
import { authFetch, buildAuthHeaders } from "../../../public/api/httpClient";

const TOURNAMENT_REGISTRATION_BASE = `${config.BASE_URL}/tournament-registrations`;
const TOURNAMENTS_PARTICIPANTS_BASE = `${config.BASE_URL}/tournaments-participants`;

async function parseJson(res) {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return { message: text || "Invalid response" };
  }
}

/** Upcoming tournaments for volunteer tournament registration (and payment form tournament dropdown). */
export const getTournamentsForVolunteerRegistration = async () => {
  const res = await authFetch(`${TOURNAMENT_REGISTRATION_BASE}/tournaments`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) {
    throw new Error(data.message || "Failed to fetch tournaments");
  }
  return data;
};

export const getStudentRegistrationPreview = async (studentId) => {
  const res = await authFetch(
    `${TOURNAMENT_REGISTRATION_BASE}/student/${encodeURIComponent(String(studentId))}/preview`,
    {
      credentials: "include",
      headers: buildAuthHeaders(),
    },
  );
  const data = await parseJson(res);
  if (!res.ok) {
    throw new Error(data.message || "Failed to load student details");
  }
  return data;
};

/** Rows you registered for tournaments (your collected payments), with student, tournament, and payment fields. */
export const getVolunteerTournamentParticipantsList = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.student_search) params.append("student_search", filters.student_search);
  if (filters.tournament_id) params.append("tournament_id", String(filters.tournament_id));
  if (filters.payment_verified !== undefined && filters.payment_verified !== "") {
    params.append("payment_verified", String(filters.payment_verified));
  }
  if (filters.registration_verified !== undefined && filters.registration_verified !== "") {
    params.append("registration_verified", String(filters.registration_verified));
  }
  if (filters.filter_column) params.append("filter_column", String(filters.filter_column));
  if (filters.filter_value != null && String(filters.filter_value).trim() !== "") {
    params.append("filter_value", String(filters.filter_value));
  }
  if (filters.date_from) params.append("date_from", filters.date_from);
  if (filters.date_to) params.append("date_to", filters.date_to);
  if (filters.tournament_timing) params.append("tournament_timing", String(filters.tournament_timing));
  if (filters.sort_by) params.append("sort_by", filters.sort_by);
  if (filters.order) params.append("order", filters.order);
  if (filters.page) params.append("page", String(filters.page));
  if (filters.limit) params.append("limit", String(filters.limit));

  const q = params.toString();
  const url = `${TOURNAMENTS_PARTICIPANTS_BASE}${q ? `?${q}` : ""}`;
  const res = await authFetch(
    url,
    {
      credentials: "include",
      headers: buildAuthHeaders(),
    },
  );
  const data = await parseJson(res);
  if (!res.ok) {
    throw new Error(data.message || "Failed to load participants");
  }
  return data;
};

export const submitTournamentRegistration = async (payload, csrfToken) => {
  const res = await authFetch(`${TOURNAMENT_REGISTRATION_BASE}/`, {
    method: "POST",
    credentials: "include",
    headers: buildAuthHeaders(
      csrfToken ? { "X-CSRF-Token": csrfToken } : {},
    ),
    body: JSON.stringify(payload),
  });
  const data = await parseJson(res);
  if (!res.ok) {
    const err = new Error(data.message || "Tournament registration failed");
    err.details = data.details;
    err.status = res.status;
    throw err;
  }
  return data;
};
